import { computed } from 'vue'

export function useFeatureFlags() {
  // Sprawdź czy artykuły są włączone przez zmienną środowiskową
  const isArticlesEnabled = computed(() => {
    return import.meta.env.VITE_ENABLE_ARTICLES !== 'false'
  })

  // Sprawdź czy analytics są włączone przez zmienną środowiskową
  const isAnalyticsEnabled = computed(() => {
    return import.meta.env.VITE_ENABLE_ANALYTICS === 'true'
  })

  return {
    isArticlesEnabled,
    isAnalyticsEnabled
  }
}
